<template>
    <div class="container mx-auto px-4 py-8">
      <h1 class="text-3xl font-bold mb-6">Settings</h1>
      <div class="mb-6">
        <nav class="flex space-x-4">
          <button
            @click="activeTab = 'profile'"
            :class="['px-3 py-2 rounded-md', activeTab === 'profile' ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:bg-gray-100']"
          >
            Edit Profile
          </button>
          <button
            @click="activeTab = 'settings'"
            :class="['px-3 py-2 rounded-md', activeTab === 'settings' ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:bg-gray-100']"
          >
            Account Settings
          </button>
        </nav>
      </div>
      <div v-if="activeTab === 'profile'">
        <h2 class="text-2xl font-semibold mb-4">Edit Profile</h2>
        <form @submit.prevent="updateProfile" class="space-y-4">
          <div>
            <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
            <input type="text" id="name" v-model="profile.name" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
            <input type="email" id="email" v-model="profile.email" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div>
            <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Save Changes
            </button>
          </div>
        </form>
      </div>
      <div v-else-if="activeTab === 'settings'">
        <h2 class="text-2xl font-semibold mb-4">Account Settings</h2>
        <form @submit.prevent="updateSettings" class="space-y-4">
          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">New Password</label>
            <input type="password" id="password" v-model="settings.password" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div>
            <label for="confirmPassword" class="block text-sm font-medium text-gray-700">Confirm New Password</label>
            <input type="password" id="confirmPassword" v-model="settings.confirmPassword" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div>
            <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Update Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
  // import { ref, reactive } from 'vue'
  // import { useAuthStore } from '../stores/auth'
  
  // const authStore = useAuthStore()
  
  // const activeTab = ref('profile')
  
  // const profile = reactive({
  //   name: authStore.user?.name || '',
  //   email: authStore.user?.email || ''
  // })
  
  // const settings = reactive({
  //   password: '',
  //   confirmPassword: ''
  // })
  
  // const updateProfile = async () => {
  //   try {
  //     await authStore.updateProfile(profile)
  //     alert('Profile updated successfully')
  //   } catch (error) {
  //     console.error('Failed to update profile:', error)
  //     alert('Failed to update profile')
  //   }
  // }
  
  // const updateSettings = async () => {
  //   if (settings.password !== settings.confirmPassword) {
  //     alert('Passwords do not match')
  //     return
  //   }
  //   try {
  //     await authStore.updatePassword(settings.password)
  //     alert('Password updated successfully')
  //     settings.password = ''
  //     settings.confirmPassword = ''
  //   } catch (error) {
  //     console.error('Failed to update password:', error)
  //     alert('Failed to update password')
  //   }
  // }
  </script>